import { Component } from 'react'
import { connect } from 'react-redux'
import SuggestedContent from 'components/SuggestedContent'
import { fetchSuggested } from './actions'
import { selectTutorials, selectFaqs, selectIsFetching } from './selectors'

class SuggestedContentContainer extends Component {
  state = { expandedFaq: null }

  componentDidMount() {
    const { contentId, contentType, deviceId } = this.props
    this.props.fetchSuggested(contentId, contentType, deviceId)
  }

  handleFaqClick = (id, e) => {
    e.preventDefault()
    this.setState({ expandedFaq: id === this.state.expandedFaq ? null : id })
  }

  render() {
    return (
      <SuggestedContent
        {...this.props}
        expandedFaq={this.state.expandedFaq}
        handleFaqClick={this.handleFaqClick}
      />
    )
  }
}

const mapStateToProps = (state) => ({
  tutorials: selectTutorials(state),
  faqs: selectFaqs(state),
  isFetching: selectIsFetching(state)
})

const mapDispatchToProps = (dispatch) => ({
  fetchSuggested: (id, contentType, deviceId) =>
    dispatch(fetchSuggested.request(id, contentType, deviceId))
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SuggestedContentContainer)
